/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_UnterlagenInputs */

const de__field_unterlagen = /** @type {(inputs: _Field_UnterlagenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterlagen`)
};

/**

* @param {_Field_UnterlagenInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_unterlagen = /** @type {((inputs?: _Field_UnterlagenInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_UnterlagenInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_unterlagen(inputs)
});